import { BIOMETRICS_EXISTING_USER_FLOW } from 'Store/userBiometrics/constants';

import type { UserBiometricsState } from './types';

const initialState: UserBiometricsState = {
  flow: BIOMETRICS_EXISTING_USER_FLOW,
  isCompleted: false,
  isInitialized: false,
};

export default initialState;
